"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtPuzzle = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtPuzzle = function SvgBtPuzzle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.3904 11.3086C20.94 11.1665 20.4567 11.1665 20.0062 11.3086V7.50024C20.0062 7.22398 19.7822 7 19.506 7H7.50024C7.22398 7 7 7.22398 7 7.50024V19.506C7 19.7822 7.22398 20.0062 7.50024 20.0062H11.3086C10.9263 21.2182 11.599 22.5106 12.811 22.8928C14.023 23.275 15.3155 22.6024 15.6976 21.3904C15.8397 20.9399 15.8397 20.4566 15.6976 20.0061H19.506C19.7822 20.0061 20.0062 19.7822 20.0062 19.5059V15.6976C21.2182 16.0798 22.5106 15.4071 22.8928 14.1951C23.2751 12.9832 22.6024 11.6908 21.3904 11.3086ZM21.102 14.7392C20.8392 14.8252 20.5557 14.8252 20.2928 14.7392L19.664 14.5296C19.4019 14.4423 19.1187 14.584 19.0314 14.8461C19.0144 14.897 19.0058 14.9502 19.0057 15.0038V19.0057H15.0038C14.7276 19.0059 14.5038 19.2301 14.504 19.5063C14.504 19.5599 14.5126 19.6132 14.5296 19.664L14.7392 20.2928C14.9627 20.9755 14.5904 21.7101 13.9077 21.9335C13.225 22.1569 12.4904 21.7847 12.267 21.102C12.181 20.8391 12.181 20.5557 12.267 20.2928L12.4766 19.664C12.5639 19.4019 12.4222 19.1186 12.1601 19.0313C12.1092 19.0144 12.056 19.0057 12.0024 19.0057H8.00048V8.00048H19.0057V12.0024C19.0059 12.2786 19.2301 12.5024 19.5063 12.5022C19.5599 12.5022 19.6132 12.4936 19.664 12.4766L20.2928 12.267C20.9755 12.0436 21.7101 12.4158 21.9335 13.0985C22.157 13.7812 21.7847 14.5158 21.102 14.7392Z",
    fill: "currentColor"
  }));
};

exports.SvgBtPuzzle = SvgBtPuzzle;